// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table[data-v-88cd9e0a] {\r\n  overflow-x:scroll;\r\n  overflow-y:scroll;\n}\n#collapse1[data-v-88cd9e0a]{\r\n  /*overflow-y:scroll;*/\r\n  overflow-x:scroll;\r\n  /*height:200px;*/\r\n  width:1000px;\n}\r\n", ""]);
// Exports
module.exports = exports;
